// Vue
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueAnalytics from 'vue-analytics';
import Fragment from 'vue-fragment';

// F7
import Framework7 from 'framework7/framework7.esm.bundle.js';
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';
import 'framework7/css/framework7.bundle.css';

// Chartist
import chartist from 'vue-chartist';
import 'chartist/dist/chartist.css';

// Sentry error tracking
import * as Sentry from '@sentry/browser';

// Icons and App Custom Styles
import './css/app.scss';
import './css/fonts.scss';
import './css/icons.scss';
import 'plyr/dist/plyr.css';

// App Component
import App from './app.vue';
import 'globals';
import ListoryStore from './store';
import PlayButton from './components/play-button.vue';
import BackButton from './components/back-button.vue';
import TransparentNavbar from './components/transparent-navbar.vue';

// Unity Bridge
import UnityBridge from '@/unity-bridge';

import './registerServiceWorker';
import messages from './messages.json';

// Init Plugins
Framework7.use(Framework7Vue);
Vue.use(VueI18n);
Vue.use(chartist);
Vue.use(Fragment.Plugin);
Vue.use(VueAnalytics, {
    id: 'UA-139861939-1',
    fields: {
        anonymizeIp: true
    }
});

// Enable sentry on PROD
if (process.env.VUE_APP_API_ENV === 'prod') {
    Sentry.init({ dsn: 'https://a23ad3c225d94fb596acfc448e1d2d1c@sentry.io/1451097' });
}

// Initialize mapbox

import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_ACCESS_TOKEN;

// Global components
Vue.component('play-button', PlayButton);
Vue.component('transparent-navbar', TransparentNavbar);

const i18n = new VueI18n({
    locale: 'de', // Default language
    fallbackLocale: 'de',
    silentFallbackWarn: true,
    messages: messages
});

const store = new ListoryStore({ i18n });
Vue.prototype.$store = store;

new Vue({
    i18n,
    render(root) {
        return root(App);
    },
    beforeCreate() {
        this.$store.init();
    },
    async created() {
        // let unity know that pwa is ready!
        const unityBridge = new UnityBridge();
        unityBridge.send('pwaIsReady', 'ready');

        await this.$store.waitUntilReady();

        // Test unlock some pois
        // for (let i = 1; i <= 91; i++) {
        //     const poi = store.getPoi(i);
        //     await store.poiJournalService.setPoiReadyToUnlock(poi);
        //     await store.poiJournalService.setPoiUnlocked(poi);
        // }

        // Activate language from settings
        this.$i18n.locale = this.$store.settings.language;
    }
}).$mount('#app');
